import { useImportProduct } from "./useImportProduct.js"

export const usePrepareAndImportProduct = () => {
	const importProduct = useImportProduct()

	return async (input, productUrl) => {
		let toImport = {
			...input.product,
			variants: input.product.variants.map((v) => ({
				price: v.price,
				options: v.options,
				compareAtPrice: v.compareAtPrice,
				mediaSrc: v.imageSrc,
				taxable: v.taxable,
				sku: v.sku,
			})),
		}

		const media = []
		toImport.variants.map((v) => {
			if (
				v?.mediaSrc &&
				!media.some((m) => m.originalSource === v.mediaSrc)
			) {
				media.push({
					mediaContentType: "IMAGE",
					originalSource: v.mediaSrc,
					isVariantMedia: true,
				})
			}
		})

		// Set the main product image that the customer will see even if duplicated in the variants images
		if (toImport.image?.src) {
			media.push({
				mediaContentType: "IMAGE",
				originalSource: toImport.image.src,
				isVariantMedia: false,
			})
		} else if (toImport.images?.[0]?.src) {
			media.push({
				mediaContentType: "IMAGE",
				originalSource: toImport.images[0].src,
				isVariantMedia: false,
			})
		}
		delete toImport.image

		toImport.images?.map((i) => {
			if (i?.src && !media.some((m) => m.originalSource === i.src)) {
				media.push({
					mediaContentType: "IMAGE",
					originalSource: i.src,
					isVariantMedia: false,
				})
			}
		})
		delete toImport.images

		const { data, errors } = await importProduct({
			productUrl,
			input: toImport,
			media,
			aiOrders: input.aiOrders || [],
		})

		return { data, errors }
	}
}
